import { CheckboxField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerIsPhoneCss = "cldj75";
const containerCss = "c1c4gbrx";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const flexContainerCss = "f1r6k50p";
const FlexContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexContainerCss, props.className)} />;
});
const buttonContainerIsPhoneCss = "b1gkam3y";
const buttonContainerCss = "b18gru9";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, {
    [buttonContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledButtonCss = "s107z9e3";
const StyledButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
export const Footer = ({
  onBack,
  isLoading,
  showCancellationPolicyCheckbox,
  activeSendButton
}) => <Container>
    <FlexContainer>
      {showCancellationPolicyCheckbox && <CheckboxField label={I18n.t('publisher.workflows.actions.edit_email_form.include_cancellation_policy')} proTip={I18n.t('publisher.workflows.actions.edit_email_form.cancel_policy_tooltip')} name="include_cancellation_policy" disabled={isLoading} />}
    </FlexContainer>
    <ButtonContainer>
      <StyledButton decoration="ghost" onClick={onBack} loading={isLoading}>
        {I18n.t('publisher.contacts.buttons.back')}
      </StyledButton>
      <StyledButton decoration="primary" type="submit" loading={isLoading} disabled={!activeSendButton}>
        {I18n.t('publisher.contacts.buttons.send_email')}
      </StyledButton>
    </ButtonContainer>
  </Container>;

require("./footer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");